import { apiUrl } from '../api/client'
import { getAttributionSubId } from '../lib/attribution'
import { nonBasicDeckLines } from './manapool'

/**
 * Card Kingdom buy links. Unlike TCGPlayer and Mana Pool these are NOT built
 * against the store: they point at the API's first-party redirect routes,
 * which own Card Kingdom's URL format and partner code. A wrong destination or
 * a changed code is then an API deploy, never a client release. The API also
 * owns front-face conversion and dedupe, so names are sent exactly as the
 * deck spells them ("Fire // Ice" included).
 *
 * `src=web` names the platform; `ref` carries a captured partner slug and is
 * omitted when attribution is the platform default, which the server already
 * assumes.
 */
function withAttribution(params: URLSearchParams): URLSearchParams {
  // eslint-disable-next-line i18next/no-literal-string -- URL param name
  params.set('src', 'web')
  const ref = getAttributionSubId()
  // eslint-disable-next-line i18next/no-literal-string -- URL param name
  if (ref !== 'web') params.set('ref', ref)
  return params
}

export function cardkingdomCardUrl(cardName: string): string {
  const params = withAttribution(new URLSearchParams({ name: cardName }))
  return apiUrl(`/buy/cardkingdom/card?${params.toString()}`)
}

/** Whole-list link: basics excluded and duplicate names summed client-side,
 *  the same list Mana Pool receives. */
export function cardkingdomBulkBuyUrl(cards: { name: string; quantity?: number }[]): string {
  const params = withAttribution(new URLSearchParams({ c: nonBasicDeckLines(cards) }))
  return apiUrl(`/buy/cardkingdom/deck?${params.toString()}`)
}
